import { render, staticRenderFns } from "./ClientFactureProfile.vue?vue&type=template&id=87207582&"
import script from "./ClientFactureProfile.vue?vue&type=script&lang=js&"
export * from "./ClientFactureProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports